import React from 'react';
import { testimonials } from '../mockData';
import { Star, Quote } from 'lucide-react';

const Testimonials = () => {
  return (
    <section id="testimonials" className="section-standard">
      <div className="container">
        <div className="section-header">
          <h2 className="heading-2">TESTIMONIOS Y REPUTACIÓN</h2>
          <div className="title-underline"></div>
        </div>

        {/* Google Rating */}
        <div className="google-rating">
          <div className="rating-stars">
            {[...Array(5)].map((_, i) => (
              <Star key={i} size={32} fill="#d9fb06" color="#d9fb06" />
            ))}
          </div>
          <p className="rating-text heading-4">5.0 / 5.0</p>
          <p className="rating-source caption">VALORACIÓN EN GOOGLE</p>
        </div>

        {/* Testimonials Grid */}
        <div className="testimonials-grid">
          {testimonials.map(testimonial => (
            <div key={testimonial.id} className="testimonial-card">
              <Quote size={40} className="quote-icon" />
              <p className="body-small testimonial-text">"{testimonial.comment}"</p>
              <div className="testimonial-author">
                <p className="heading-6">{testimonial.name}</p>
                <p className="caption">{testimonial.role}</p>
                <div className="testimonial-stars">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} size={16} fill="#d9fb06" color="#d9fb06" />
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;